.members-block {
    background-color: #fff;
    background-image: url('../../../assets/images/banner2_bg.png');
    background-repeat: no-repeat;
    background-position: bottom;
    background-size: contain;
    height: 606px;
    @media (max-width: 992px) {
        height: auto;
    }
}
.members {
    width: 80%;
    max-width: 1280px;
    padding-top: 2rem;
    border-radius: 6px;
    margin: 0 auto;
    transform: translateY(-127px);
    background-image: url('../../../assets/images/banner4_bg.png');
    background-repeat: no-repeat;
    background-position: center;
    background-size: 1029px 532px;
    text-align: center;
    background-color: #fff;
    @media (max-width: 992px) {
        width: 98%;
        height: auto;
        padding: 1rem 0;
    }
    @media (max-width: 480px) {
        width: 98%;
        height: auto;
        padding: 1rem 0;
    }
    .title {
        font-size: 20px;
        font-weight: bold;
    }
    .sub-title {
        font-size: 20px;
        line-height: 20px;
        margin-bottom: 34px;
        margin-top: 0px;
        color: rgba(0, 0, 0, 0.1);
    }
    .members-list {
        padding-top: 1rem;
        padding-bottom: 1rem;
        text-align: left;
    }
}
